import { render, staticRenderFns } from "./TagsCategpryInstance.vue?vue&type=template&id=d1a332b6&"
import script from "./TagsCategpryInstance.vue?vue&type=script&lang=js&"
export * from "./TagsCategpryInstance.vue?vue&type=script&lang=js&"
import style0 from "./TagsCategpryInstance.vue?vue&type=style&index=0&id=d1a332b6&prod&lang=scss&"
import style1 from "./TagsCategpryInstance.vue?vue&type=style&index=1&id=d1a332b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports